// extracted by mini-css-extract-plugin
export default {"checkbox":"CheckBoxField_checkbox__0GN+h","checkboxLabel":"CheckBoxField_checkboxLabel__dWQyO","checkboxError":"CheckBoxField_checkboxError__gJkPD"};